import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const T = {
  heading: { de: 'Nehmen Sie Kontakt auf', en: 'Get in Touch' },
  sub: {
    de: 'Haben Sie Fragen zu unserer Unternehmensgruppe oder möchten Sie eine Zusammenarbeit besprechen? Wir freuen uns auf Ihre Nachricht.',
    en: 'Do you have questions about our corporate group or would you like to discuss a collaboration? We look forward to hearing from you.',
  },
  cta: { de: 'Kontakt', en: 'Contact' },
};

export const ContactCTASection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const { language } = useLanguage();

  return (
    <section ref={ref} data-testid="contact-cta-section" className="section-spacing bg-[#0F1A2E] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="cta-grid" width="80" height="80" patternUnits="userSpaceOnUse">
              <path d="M 80 0 L 0 0 0 80" fill="none" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#cta-grid)" />
        </svg>
      </div>
      <div className="absolute -right-20 -bottom-20 w-80 h-80 bg-[#F5A623] opacity-10 transform rotate-45"></div>

      <div className="container-main relative z-10">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={isInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.7 }} className="max-w-3xl mx-auto text-center">
          <div className="flex justify-center mb-6"><div className="accent-line"></div></div>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-white mb-6">{T.heading[language]}</h2>
          <p className="text-lg text-white/80 mb-10 leading-relaxed">{T.sub[language]}</p>
          <Link to="/kontakt" data-testid="cta-contact-button" className="inline-flex items-center bg-white text-[#0F1A2E] px-10 py-5 text-sm tracking-widest uppercase font-semibold hover:bg-[#F5A623] hover:text-white transition-colors duration-300">
            {T.cta[language]}
            <ArrowRight size={18} className="ml-3" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactCTASection;
